var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTerraforminline = function SvgTerraforminline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.602 21.652v19.687l17.393-9.838V11.793l-17.393 9.859ZM23.3 11.793l17.395 9.859v19.687L23.3 31.49V11.793ZM4 .8v19.697l17.394 9.85V10.648L4 .799ZM23.303 53.35 40.697 63.2V43.502l-17.394-9.849v19.698Z",
    fill: "currentColor"
  })));
};

export default SvgTerraforminline;